
(() => {
  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-localization-toggle]');
      this.list = this.querySelector('[data-localization-list]');
      if (!this.toggle || !this.list) return;

      this.trap = this.hasAttribute('data-localization-trap');

      this.toggle.addEventListener('click', () => this.setOpen(this.list.hasAttribute('hidden')));

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.setOpen(false); this.toggle.focus(); }
      });

      this.onDocClick = (e) => { if (!this.contains(e.target)) this.setOpen(false); };
      document.addEventListener('click', this.onDocClick);

      this.initRegions();
    }

    initRegions() {
      this.regionGroup = this.querySelector('[data-region-group]');
      this.langGroup = this.querySelector('[data-lang-group]');
      if (!this.regionGroup || !this.langGroup) return;

      this.regions = [...this.regionGroup.querySelectorAll('[data-region]')];
      this.form = this.querySelector('form');

      const keys = (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        this.apply();
      };
      this.regionGroup.addEventListener('keydown', keys);
      this.langGroup.addEventListener('keydown', keys);

      const pickRegion = (e) => {
        const hit = e.target.closest('[data-region]');
        if (!hit) return null;
        this.regions.forEach((r) => { if (r !== hit) r.checked = false; });
        this.showRegion(hit.dataset.region, hit.dataset.region !== this.startRegion);
        return hit;
      };

      this.regionGroup.addEventListener('change', pickRegion);
      this.regionGroup.addEventListener('click', pickRegion);

      this.langGroup.addEventListener('click', (e) => {
        if (!e.target.closest('.sa-hdr__loc-radio')) return;
        this.apply();
      });

      this.form?.addEventListener('submit', (e) => {
        const active = this.regions.find((r) => r.checked);
        if (!active || active.dataset.region !== 'ua') return;

        e.preventDefault();
        const lang = (this.visibleLangs || []).find((input) => input.checked);
        const url = (lang && lang.value) || active.dataset.site;
        if (url) window.location.href = url;
      });

      const start = this.regions.find((r) => r.checked);
      this.startRegion = start ? start.dataset.region : 'world';
      this.showRegion(this.startRegion, false);
    }

    apply() {
      if (this.applying) return;
      const active = this.regions.find((r) => r.checked);
      const lang = (this.visibleLangs || []).find((input) => input.checked);
      if (!lang) return;

      if (active && active.dataset.region === 'ua') {
        const url = lang.value || active.dataset.site;
        if (!url) return;
        this.applying = true;
        window.location.href = url;
        return;
      }

      if (!this.form) return;
      this.applying = true;
      if (this.form.requestSubmit) this.form.requestSubmit();
      else this.form.submit();
    }

    showRegion(region, reset) {
      let visibleChecked = false;
      const visible = [];
      this.langGroup.querySelectorAll('[data-for-region]').forEach((chip) => {
        const on = chip.dataset.forRegion === region;
        chip.hidden = !on;
        const input = chip.querySelector('input');
        if (!input) return;
        input.disabled = !on;
        if (!on || reset) input.checked = false;
        if (on) {
          visible.push(input);
          if (input.checked) visibleChecked = true;
        }
      });

      if (!reset && !visibleChecked && visible.length) {
        const current = this.langGroup.dataset.currentLang;
        (visible.find((input) => input.value === current) || visible[0]).checked = true;
      }
      this.visibleLangs = visible;
      this.langGroup.toggleAttribute('data-awaiting-pick', !visible.some((input) => input.checked));
    }

    setOpen(open) {

      if (open === !this.list.hasAttribute('hidden')) return;

      this.list.toggleAttribute('hidden', !open);
      this.toggle.setAttribute('aria-expanded', String(open));
      this.classList.toggle('is-open', open);

      if (!this.trap) {

        if (open) (this.list.querySelector('[aria-selected="true"]') || this.list.querySelector('button'))?.focus();
        return;
      }

      if (open) {

        this.toggle.focus({ preventScroll: true });

        const start = this.list.querySelector('.sa-hdr__loc-radio:checked')
          || this.list.querySelector('[aria-selected="true"]');
        window.ThemeUtils?.trapFocus(this.list, start || undefined);
      } else {

        window.ThemeUtils?.releaseFocus(this.list);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);

      if (this.trap && this.list && !this.list.hasAttribute('hidden')) {
        window.ThemeUtils?.releaseFocus(this.list);
      }
    }
  }

  if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);
})();
